<template>
  <div>
    <el-dialog v-model="mostraFormulario" size="medium" top="5%" :show-close="false">
      <el-row>
        <el-col :span="14">
          <h1 style="margin-top: 0; margin-bottom: 0;">Quer transformar sua MEI em ME?</h1>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="10">
          <h3>Somos um Escritório de Contabilidade Online que migra sua MEI para ME e faz sua contabilidade de um jeito simples, moderno e online.</h3>

          <h4>Conte com a orientação e o trabalho de especialistas para começar certo!</h4>
          <h5>Preencha agora mesmo o formulário e receba uma cotação de nossos serviços</h5>
        </el-col>

        <el-col :span="14">
          <div key="form" v-loading="isLoading" element-loading-text="Enviando os dados, aguarde...">
            <el-form :model="form" :rules="rules" ref="form" style="margin-left: 5px;">
              <el-form-item label="Seu nome (Obrigatório)" prop="nome">
                <el-input v-model="form.nome"></el-input>
              </el-form-item>

              <el-form-item label="Email (Obrigatório)" prop="email">
                <el-input v-model="form.email" placeholder="Email"></el-input>
              </el-form-item>

              <el-form-item label="Telefone com DDD (Somente números)" prop="telefone">
                <div class="el-input">
                  <input type="text" v-model="form.telefone" placeholder="Fixo ou Celular" v-mask="mascaraTelefone" @input="atualizaMascara" class="el-input__inner" />
                </div>
              </el-form-item>

              <el-form-item prop="selecionadas">
                <label class="el-form-item__label" style="width: 100%; text-align: left;">Qual tipo de empresa você quer migrar para ME (Obrigatório)"</label>
                <el-checkbox-group v-model="form.selecionadas">
                  <el-checkbox v-for="opcao in form.opcoes" :label="opcao" :key="opcao" style="font-weight: normal;">{{ opcao }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <vue-recaptcha :sitekey="sitekey" @verify="verifyRecaptcha" @expired="recaptchaExpired" badge="inline" size="invisible" ref="recaptcha"></vue-recaptcha>

              <el-form-item>
                <el-button :disabled="!isValid" @click.prevent="onSubmit" type="success" style="float: right;">Enviar</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <el-button type="success" @click="mostraFormulario = true">Migrar MEI para ME</el-button>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import AwesomeMask from 'awesome-mask'

export default {
  components: {
    VueRecaptcha
  },

  directives: {
    'mask': AwesomeMask
  },

  data () {
    return {
      sitekey: '6LdyLyIUAAAAAPjoJrn4oVRblZ1WBX5yTSPB36uL',
      isLoading: false,
      isReseting: false,
      mascaraTelefone: '(99) 9999-9999',
      form: {
        recaptcha: '',
        nome: '',
        email: '',
        telefone: '',
        opcoes: ['Empresa de serviços', 'Empresa de comércio', 'Outro tipo'],
        selecionadas: [],
        valid: false
      },
      rules: {
        nome: [
          { required: true, message: 'O nome é obrigatório', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'O email é obrigatório', trigger: 'blur' },
          { type: 'email', message: 'Você deve digitar um email válido', trigger: 'blur' }
        ],
        telefone: [
          { required: true, pattern: /\((10)|([1-9][1-9])\) [0-9]{4,5}-[0-9]{4}/, message: 'Você deve digitar um telefone no formato correto (Fixo ou Celular): Ex. (99) 9999-9999 ou (99) 99999-9999', trigger: 'blur' }
        ],
        selecionadas: [
          { type: 'array', required: true, message: 'Você deve selecionar uma das opções', trigger: 'blur' }
        ]
      },
      mostraFormulario: false
    }
  },

  computed: {
    isValid () { return this.form.valid }
  },

  watch: {
    form: {
      handler () {
        this.$nextTick(() => {
          if (!this.isReseting) {
            this.verifyValidation()
          } else {
            this.isReseting = false
          }
        })
      },
      deep: true
    }
  },

  methods: {
    atualizaMascara (ev) {
      if (ev.target.value.indexOf(') 9') !== -1) {
        this.mascaraTelefone = '(99) 99999-9999'
      } else {
        this.mascaraTelefone = '(99) 9999-9999'
      }
    },

    onSubmit () {
      console.log(this.$refs.recaptcha)
      this.$refs.recaptcha.execute()
    },

    verifyRecaptcha (recaptcha) {
      console.log('here')
      this.form.recaptcha = recaptcha

      this.sendForm()
    },

    recaptchaExpired () {
      this.$message({ type: 'error', message: 'A verificação expirou, por favor, faça novamente.' })

      this.form.recaptcha = ''
    },

    verifyValidation () {
      this.$refs.form
        .validate((valid) => {
          this.form.valid = valid

          return valid
        })
    },

    sendForm () {
      this.isLoading = true

      console.log(this.isValid)

      console.log('oi')

      setTimeout(() => {
        if (this.isValid) {
          this.$http.post('https://api.alternativacont.com.br/mei-para-me', this.form)
            .then(response => {
              this.$swal({
                animation: 'slide-from-top',
                title: 'Enviado com sucesso!',
                text: 'Aguarde nosso contato',
                type: 'success',
                timer: 5000,
                showConfirmButton: false
              }).catch(this.$swal.noop)

              this.$nextTick(() => {
                this.backToBeginSetup()
              })
            })
            .catch(response => {
              // this.$http.post('http://localhost:80801/report', response)

              this.$swal({
                animation: 'slide-from-top',
                title: 'Houve um erro',
                html: `Por favor tente novamente mais tarde ou entre em contato.`,
                type: 'error',
                showConfirmButton: false
              }).catch(this.$swal.noop)

              this.$nextTick(() => {
                this.backToBeginSetup()
              })
            })
        }
      }, 2000)
    },

    backToBeginSetup () {
      this.isReseting = true
      this.$refs.recaptcha.reset()
      this.$refs.form.resetFields()
      this.isLoading = false
      this.mostraFormulario = false
    }
  }
}
</script>

<style>
/*@import '~element-ui/lib/theme-default/index.css';*/

.el-dialog__body {
  padding-top: 0; padding-bottom: 0;
}

.el-form-item__label {
    width: 100%; text-align: left;
}

.el-radio {
  font-weight: normal
}

.grecaptcha-badge {
  display: none;
}

.el-checkbox:last-child {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// MeiParaMe.vue?90ae38d8